import ClientRetainerTaskModal from './ClientRetainerTaskModal';
import IdentityVerificationTaskModal from './IdentityVerificationTaskModal';
import SourceOfFundsTaskModal from './SourceOfFundsTaskModal';

import { useDispatch } from 'react-redux';


const ClientTasks = () => {

    const dispatch = useDispatch();

    return (
        <>
            <ClientRetainerTaskModal dispatch={dispatch} />
            <IdentityVerificationTaskModal dispatch={dispatch} />
            <SourceOfFundsTaskModal dispatch={dispatch} />
        </>
    );
}

export default ClientTasks;
